export const SubheaderPanel = ({
  title,
  children,
}: {
  title: string;
  children: React.ReactNode;
}) => {
  return (
    <div className='space-y-3'>
      <div className='text-base font-medium text-gray-900'>{title}</div>
      <div>{children}</div>
    </div>
  );
};
